'use strict';

const angular = require('angular');

/**
 * Removes server error when user updates input
 */
export default angular.module('conduu.ap.components.mongooseError', [])
  .directive('mongooseError', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, attrs, ngModel) {
        element.on('keydown', () => ngModel.$setValidity('mongoose', true));
      }
    };
  }).name;



// WEBPACK FOOTER //
// ./client/~ap/components/mongoose-error/mongoose-error.directive.js